import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultDlpConfig, getDlpTemplateConfig } from './cfg.dlp.default';

const cfg = {
  policyType: 2,
  policySubType: 0,
  holderType: 2,
};

export function getDlpSharePointTemplateConfig(
  t: TFunction<'translation'>,
  accountEmail: string | undefined,
  mipEnabled: boolean
) {
  let ntfI18nReplaceKeys = [];
  if (mipEnabled) {
    ntfI18nReplaceKeys = [
      'policy.policyTemplate.SP.tmDpfilters.notification.ntfAdminSubject',
      'policy.policyTemplate.SP.tmDpfilters.notification.ntfInternalRecipientSubject',
      'policy.policyTemplate.MIP_SP.tmDpfilters.notification.ntfAdminMessage',
      'policy.policyTemplate.MIP_SP.tmDpfilters.notification.ntfInternalRecipientMessage',
    ];
  } else {
    ntfI18nReplaceKeys = [
      'policy.policyTemplate.SP.tmDpfilters.notification.ntfAdminMessage',
      'policy.policyTemplate.SP.tmDpfilters.notification.ntfAdminSubject',
      'policy.policyTemplate.SP.tmDpfilters.notification.ntfInternalRecipientMessage',
      'policy.policyTemplate.SP.tmDpfilters.notification.ntfInternalRecipientSubject',
    ];
  }
  const tempConfig = getDefaultDlpConfig();
  merge(tempConfig, cfg);
  return getDlpTemplateConfig(
    t,
    tempConfig,
    accountEmail,
    [],
    ntfI18nReplaceKeys
  );
}
